import { useEffect, useState } from "react";
import { Box, Button, Collapse } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { sources } from "src/mockup/sources";
import InfoIcon from '@mui/icons-material/Info';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { mobile, isMobileWebBrowser } from "src/utils/platformUtils";

interface SourceIconProps {
    customPaddingBottom?: number;
    customPaddingTop?: number;
    currentStoryIndex?: number;
}

function SourceIcon({ customPaddingBottom, customPaddingTop, currentStoryIndex }: SourceIconProps) {
    //state for expanded or collapsed
    const [isExpanded, setIsExpanded] = useState(false);
    const isMobile = isMobileWebBrowser() || mobile;
    // function to toggle the expanded or collapsed state
    const handleToggle = (e) => {
        e.stopPropagation(); // prevent the event on change stories in sections
        setIsExpanded(!isExpanded);
    };

    useEffect(() => {
        setIsExpanded(false);
    }, [currentStoryIndex]);

    return (
        <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
                // width:"200px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                pt: customPaddingTop || 0,
                pb: customPaddingBottom,
                pr: isMobile ? 0 : 1,
                margin: "0 auto",
                backgroundColor: "transparent",
                position: "relative",
                zIndex: 1000,
            }}
        >
            <Collapse
                in={isExpanded}
                timeout={300}
                sx={{
                    position: "absolute",
                    bottom: "100%",
                    width: "100%",
                    backgroundColor: "#000000",
                }}
            >
                <Box
                    onClick={(e) => e.stopPropagation()}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        // pr: 2,
                        pt: 1,
                        gap: 0.5,
                        marginBottom: 0.5,
                    }}
                >
                    {sources.map((source) => (
                        <Box
                            key={source.id}
                            component="img"
                            src={source.image}
                            alt={source.name}
                            sx={{
                                width: source.width,
                                height: source.height,
                                objectFit: "contain",
                                transform: `translateY(${isExpanded ? "0" : "20px"})`,
                                transition: "transform 0.3s ease-in-out",
                            }}
                        />
                    ))}
                </Box>
            </Collapse>

            <Button
                onClick={handleToggle}
                variant="text"
                // startIcon={isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                sx={{
                    color: "#ffffff",//FF672D
                    textTransform: "none",
                    fontSize: "16px",
                    fontFamily: "Roboto, sans-serif",
                    padding: 0,
                    fontWeight: 500,
                    // pl:2,
                    "&:hover": {
                        backgroundColor: "transparent",
                    },
                }}
            >
                {/* Sources ({sources.length}) */}
                <InfoOutlinedIcon />
            </Button>
        </Box>
    );
}

export default SourceIcon;
